import Close from '../src/Close';
export default Close;
